type LinkProps = {
  href: string;
  title: string;
  target?: string;
  label: string;
  [key: string]: any;
};

const Link = (props: LinkProps) => {
  const {
    children,
    target = '_blank',
    title,
    href,
    label,
    ...otherProps
  } = props;
  return (
    <a href={href} target={target} title={title} {...otherProps}>
      {/* {label} */}
    </a>
  );
};

export default Link;
